module.exports = __webpack_public_path__ + "img/emission_icon.5fd55b4e.png";